const basico3 = {
    titulo: `JavaScript: Promises y método then`,
    problemas: [
        {
            codigo: 1,
            descripcion: `No podemos escribir directamente en JavaScript la clase Promise para explicar su estructura interna, pero si podemos crear una función síncrona que nos de una idea de como está implementada la clase Promise.
Tengamos en cuenta que nuestra función es síncrona y solo tiene por objetivo entender como se logran las llamadas encadenadas de métodos then:
<code>
console.log("primero")
function PromesaFicticia(valor) {
  return {
    valor,
    then: fn => new PromesaFicticia(fn(valor))
  }
}

const p = new PromesaFicticia(10).then(valor => {
  console.log("segundo")
  return valor + 1
}).then(valor => {
  console.log("tercero")
})

console.log("cuarto")
</code>
Es importante notar los mensajes que se muestran ya que indican el orden de ejecución del algoritmo (No hay nada asíncrono en este programa).
La función PromesaFicticia recibe un valor y devuelve un objeto con un atributo que es el valor recibido y un método llamado 'then' que recibe una función y devuelve una nueva instancia de PromesaFicticia con el resultado de ejecutar la función recibida con el valor de la instancia actual.
Luego más abajo se llama a la función PromesaFicticia con el valor 10 y se ejecuta el método then con una función que devuelve el valor recibido más 1. Luego podemos encadenar las llamadas de métodos then para ejecutar el algoritmo de forma secuencial.
Es importante notar que la función PromesaFicticia es síncrona y no devuelve una promesa. Luego cuando ejecutamos la aplicación por pantalla el último mensaje que aparece es "cuarto".
`,
            programa: `const arreglo = []
let x = 1
arreglo.push(x)
function PromesaFicticia(valor) {
  return {
    valor,
    then: fn => new PromesaFicticia(fn(valor))
  }
}

let p = new PromesaFicticia(10).then(valor => {
  x++
  arreglo.push(x)
  return valor + 1
}).then(valor => {
  x++
  arreglo.push(x)
})
x++
arreglo.push(x)
console.log(arreglo)`,
            solucion: "[1, 2, 3, 4]",
        }, {
            codigo: 2,
            descripcion: `Ahora si veamos con la clase Promise como se resuelve y ejecuta en forma asincrónica el algoritmo.
<code>
console.log("primero")
function promesa(valor) {
  return new Promise((resolve) => resolve(valor))
}

let p = promesa(10).then(valor => {
  console.log("tercero")
  return valor + 1
}).then(valor => {
  console.log("cuarto")
})

console.log("segundo")
</code>
El segundo mensaje que aparece en pantalla es la última línea de código, pero queda pendiente la promesa que se resuelve y muestra el mensaje "tercero" y finalmente se encadena la ejecución de otra llamada a then y muestra el mensaje "cuarto".
Este algoritmo si es asíncrono, a diferencia del anterior que es síncrono y tenía como objetivo entender como se logran las llamadas encadenadas de métodos then que devuelve la clase Promise.`,
            programa: `const arreglo = []
let x = 0
x++
arreglo.push(x)
function promesa(valor) {
  return new Promise((resolve) => resolve(valor))
}

let p = promesa(10).then(valor => {
  x++
  arreglo.push(x)
  return valor + 1
}).then(valor => {
  x++
  arreglo.push(x)
  console.log(arreglo)
})

x++
arreglo.push(x)`,
            solucion: "[1, 2, 3, 4]",
        }, {
            codigo: 3,
            descripcion: ``,
            programa: `const arreglo = []
let x = 0
x++
arreglo.push(x)
function promesa(valor) {
  return new Promise((resolve) => resolve(valor))
}

let p = promesa(10).then(valor => {
  x++
  arreglo.push(x)
  return valor + 1
}).then(valor => {
  x++
  arreglo.push(x)
})

x++
arreglo.push(x)
console.log(arreglo)`,
            solucion: "[1, 2]",
        }, {
            codigo: 4,
            descripcion: ``,
            programa: `function promesa(valor) {
  return new Promise((resolve) => resolve(valor))
}

promesa(10).then(valor => {
  return valor + 1
}).then(valor => {
  return valor + 1
}).then(valor => {
  console.log(valor)
})`,
            solucion: "12",
        }, {
            codigo: 5,
            descripcion: ``,
            programa: `function promesa(valor) {
  return new Promise((resolve) => resolve(valor))
}

promesa(10).then(valor => {
  return valor + 2
}).then(valor => {
  return valor - 2
}).then(valor => {
  return valor * 2
}).then(valor => {
  return valor / 2
}).then(valor => {
  console.log(valor)
})`,
            solucion: "10",
        }, {
          codigo: 6,
          descripcion: `Si cuando llamamos al método 'resolve' no pasamos datos, luego en el método 'then' recibimos un valor undefined.`,
          programa: `function promesa() {
  return new Promise((resolve) => resolve())
}

promesa().then(valor => {
  console.log(valor)
})`,
          solucion: "undefined",
      }, {
        codigo: 7,
        descripcion: `Si cuando llamamos al método 'resolve' no pasamos datos, luego en el método then no recibe datos.`,
        programa: `const arreglo = ["primero"]

function promesa() {
  arreglo.push("segundo")
  return new Promise((resolve) => resolve())
}

promesa().then(() => {
  arreglo.push("cuarto")
  console.log(arreglo)
})
arreglo.push("tercero")`,
        solucion: "['primero', 'segundo', 'tercero', 'cuarto']",
    }
    ]
}

export default basico3;

